import { render, staticRenderFns } from "./EFT.vue?vue&type=template&id=020fc887&scoped=true&"
import script from "./EFT.vue?vue&type=script&lang=js&"
export * from "./EFT.vue?vue&type=script&lang=js&"
import style0 from "./EFT.vue?vue&type=style&index=0&id=020fc887&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020fc887",
  null
  
)

export default component.exports